import axios from 'axios';
import { z } from 'zod';

import { strictQuery } from 'utils/strict-query';

import { ParticipantZod } from 'types/zod/participant';
import { UserZod } from 'types/zod/user';

const UsersApi = {
    changePassword: strictQuery({
        In: z.object({ awsId: UserZod.shape.aws_id, password: z.string() }),
        Out: z.any(),
        handler: ({ awsId, password }) => axios.patch(`/users/${awsId}/password`, { value: password }),
    }),

    setPasswordIsStrong: strictQuery({
        In: z.boolean(),
        Out: z.boolean(),
        handler: (value) => axios.patch(`/users/password-is-strong/${value}`),
    }),

    checkEmailAvailable: strictQuery({
        In: z.string(),
        Out: z.object({ isPresent: z.boolean() }),
        handler: (email) => axios.get('/participants/is-email-present', { params: { email } }),
    }),

    logoutUser: strictQuery({
        In: UserZod.shape.aws_id,
        Out: z.any(),
        handler: (awsId) => axios.patch(`/users/${awsId}/logout`),
    }),

    searchParticipants: strictQuery({
        In: z.object({ email: z.string(), lastname: z.string(), phone: z.string(), epId: z.string() }),
        Out: z.array(ParticipantZod),
        handler: ({ email, lastname, phone, epId }) =>
            axios.get('/users/participants', { params: { email, 'last-name': lastname, phone, epId, dob: '' } }),
    }),

    sendPasswordChangedEmail: strictQuery({
        In: z.void(),
        Out: z.any(),
        handler: () => axios.patch('/participants/email-password-changed'),
    }),

    stopWorkingOnBehalf: strictQuery({
        In: UserZod.shape.aws_id,
        Out: z.any(),
        handler: (awsId) => axios.patch(`/users/${awsId}/stop-working-on-behalf`),
    }),

    trackCurrentSection: strictQuery({
        In: z.string(),
        Out: z.any(),
        handler: (section) => axios.put(`/users/ep/position`, null, { params: { section } }),
    }),
};

export default UsersApi;
